<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-right-headers">
      <h3>{{ $i18n.t("Fitness Certificate") }}</h3>
    </v-btn>
    <z-expense-create
      color="blue"
      style="float: right"
      x-small
      :accountCode="'VehicleExpense'"
      :entity_id="vehicle._id"
      :expenseType="'Fitness'"
      @reload="reloadInsurExpenses"
      btn
    >
      <v-btn color="cyan" x-small class="tariff-right-headers">
        + {{ $i18n.t("Add") }}
      </v-btn>
    </z-expense-create>
    <!-- <v-btn
      color="blue"
      style="float: right"
      x-small
      class="tariff-right-headers"
      target="_blank"
      :href="
        '/expense/create?accountCode=VehicleExpense&expenseType=Fitness&vehicle_id=' +
        vehicle._id
      "
      >+ {{ $i18n.t("Add") }}</v-btn
    > -->
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="12" md="6" lg="4"
        >{{ $i18n.t("Certificate No") }} :
        {{ vehicle.vehicleDetail.fitness.certificateNo }}</v-col
      >

      <v-col cols="12" sm="12" md="6" lg="4"
        >{{ $i18n.t("Issue Date") }} :
        {{ formatDate(vehicle.vehicleDetail.fitness.issueDate) }}</v-col
      >

      <v-col cols="12" sm="12" md="6" lg="4"
        >{{ $i18n.t("Expiry") }} :
        {{ formatDate(vehicle.vehicleDetail.fitness.expiry) }}</v-col
      >

      <v-col cols="12" sm="12" md="6" lg="4"
        >{{ $i18n.t("Amount") }} : {{ vehicle.vehicleDetail.fitness.currency }}
        {{ vehicle.vehicleDetail.fitness.amount }}</v-col
      >

      <v-col cols="12" sm="12" md="6" lg="4"
        >{{ $i18n.t("Issuing Authority") }} :
        {{ vehicle.vehicleDetail.fitness.issuingAuthority }}</v-col
      >

      <v-col cols="12" sm="11" md="11" lg="11"
        >{{ $i18n.t("Details") }} :
        {{ vehicle.vehicleDetail.fitness.detail }}</v-col
      >

      <v-col cols="12" sm="1" md="1" lg="1">
        <!-- <a
          v-if="vehicle.vehicleDetail.fitness.expense_id"
          :href="'/expense/' + vehicle.vehicleDetail.fitness.expense_id"
          target="_blank"
        >
          <v-icon>mdi-pencil</v-icon>
        </a> -->
        <z-expense-create
          v-if="vehicle.vehicleDetail.fitness.expense_id"
          color="blue"
          x-small
          :expenseEdit_id="vehicle.vehicleDetail.fitness.expense_id"
          @reload="reloadInsurExpenses"
          btn
        >
          <v-btn color="cyan" text fab x-small>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </z-expense-create>
      </v-col>
    </v-row>

    <v-row
      v-if="vehicle.vehicleDetail.fitness.attachments"
      style="padding: 10px 10px"
    >
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="4"
        v-for="(picture, index) in vehicle.vehicleDetail.fitness.attachments"
        :key="index"
      >
        <v-card>
          <a :href="picture.url">
            <v-img
              v-if="isPDF(picture.url)"
              src="@/assets/pdf_format.png"
              aspect-ratio="2"
              class="grey darken-4"
            ></v-img>
            <v-img
              v-else
              :src="picture.url"
              aspect-ratio="2"
              class="grey darken-4"
            ></v-img>
          </a>
          <v-row class="px-2">
            <v-col cols="12" md="12" lg="12">{{ picture.name }}</v-col>
            <v-col cols="12" md="12" lg="12">
              {{ picture.desc }}
              {{ picture.time | moment("HH:mm DD MMM YYYY") }}
            </v-col>
            <!-- <z-confirm-button
              class="close-button"
              color="red"
              fab
              :loading="loading"
              x-small
              :message="$i18n.t('Do you want to remove this attachment ?')"
              @click="deleteVehicleImage(picture.time, vehicle._id)"
            >
              <v-icon>mdi-close</v-icon>
            </z-confirm-button> -->
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <expenses :expenseType="'Fitness'" :entity_id="vehicle._id" />
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Expenses from "@/views/vehicle/Expenses.vue";

@Component({
  name: "Fitness",
  props: {
    value: {
      default: null,
    },
  },
  components: {
    Expenses,
  },
})
export default class Fitness extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
    if (!this.vehicle.vehicleDetail.fitness)
      this.vehicle.vehicleDetail.fitness = {};
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  reloadInsurExpenses() {
    this.$root.$emit("reloadExpenses", true);
    // this.$emit("reload", true);
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>